export default "__VITE_ASSET__83440954__"